import { Action } from '@ngrx/store';

export const DESTROY = '[Task Card] Destroy';

export class DestroyAction implements Action {
    readonly type = DESTROY;
}



// WEBPACK FOOTER //
// ./src/app/modals-popovers/task-card-modal/task-card-modal.actions.ts